/**
 * Global Animations
 * Maneja las animaciones genéricas de "entrada al hacer scroll" (.slide-in-element)
 * para cualquier elemento en el sitio, independientemente de su sección.
 */

class GlobalScrollAnimations {
    constructor() {
        this.observer = null;
        this.init();
    }

    init() {
        // Crear un observer único para el viewport
        const options = {
            root: null, // viewport
            rootMargin: '0px 0px -10% 0px', // Trigger un poco antes de que sea totalmente visible
            threshold: 0.1
        };

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.playAnimation(entry.target);
                    this.observer.unobserve(entry.target); // Solo animar una vez
                }
            });
        }, options);

        this.observeElements();
    }

    observeElements() {
        // Seleccionar todos los elementos con la clase que NO han sido activados aún
        const elements = document.querySelectorAll('.slide-in-element:not(.slide-in-active)');

        elements.forEach(el => {
            this.observer.observe(el);
        });
    }

    playAnimation(element) {
        // Añadir la clase que activa la transición CSS
        // Podríamos añadir un pequeño delay si quisiéramos escalonado automático,
        // pero por ahora lo mantenemos simple para respuesta inmediata.
        element.classList.add('slide-in-active');
    }
}

// Inicialización seguro (Turbo + DOMContentLoaded)
function initGlobalAnimations() {
    new GlobalScrollAnimations();
}

document.addEventListener('DOMContentLoaded', initGlobalAnimations);
document.addEventListener('turbo:load', initGlobalAnimations);
